import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=485d642a&scoped=true&"
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&id=485d642a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d642a",
  null
  
)

export default component.exports